import { render, staticRenderFns } from "./icon-asset.vue?vue&type=template&id=69a063be&scoped=true&"
import script from "./icon-asset.vue?vue&type=script&lang=js&"
export * from "./icon-asset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a063be",
  null
  
)

export default component.exports